import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumShopifyOrderTag implements BaseEnumType {
  private static allValues: EnumShopifyOrderTag[] = []; // make sure this is top-most
  
  public static inBrewman = new EnumShopifyOrderTag(0, "InBrewman", "enum_shopify_order_tag_in_brewman");
  public static noBrewman = new EnumShopifyOrderTag(1, "NoBrewman", "enum_shopify_order_tag_no_brewman");
  public static badBrewmanProduct = new EnumShopifyOrderTag(2, "BadBrewmanProduct", "enum_shopify_order_tag_bad_brewman_product");
  public static allowBrewManMiscellaneous = new EnumShopifyOrderTag(3, "AllowBrewManMiscellaneous", "enum_shopify_order_tag_allow_brew_man_miscellaneous");
  public static badBrewmanDelivery = new EnumShopifyOrderTag(4, "BadBrewmanDelivery", "enum_shopify_order_tag_bad_brewman_delivery");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumShopifyOrderTag.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isInBrewman() { return this === EnumShopifyOrderTag.inBrewman; }
  public isNoBrewman() { return this === EnumShopifyOrderTag.noBrewman; }
  public isBadBrewmanProduct() { return this === EnumShopifyOrderTag.badBrewmanProduct; }
  public isAllowBrewManMiscellaneous() { return this === EnumShopifyOrderTag.allowBrewManMiscellaneous; }
  public isBadBrewmanDelivery() { return this === EnumShopifyOrderTag.badBrewmanDelivery; }

  public static getValues(): readonly EnumShopifyOrderTag[] {
    return EnumShopifyOrderTag.allValues;
  }

  public static getValuesExcept0(): readonly EnumShopifyOrderTag[] {
    return EnumShopifyOrderTag.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumShopifyOrderTag {
    const found = EnumShopifyOrderTag.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumShopifyOrderTag - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumShopifyOrderTag): EnumShopifyOrderTag {
    const found = name ? EnumShopifyOrderTag.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumShopifyOrderTag - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumShopifyOrderTag>): boolean {
    return this.key === other?.key;
  }
}